module.exports = __webpack_public_path__ + "static/media/img-1.f9eb5039.png";